import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from '../../generic.service';
import { TroubleShootEhtService } from '../service/trouble-shoot-eht.service';
import { TroubleShootEs2000Service } from '../service/trouble-shoot-es2000.service';
import { MachineType } from '../../landing-page/service/machineType';
import { Subscription } from 'rxjs';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { TroubleShootEh500sService } from '../service/trouble-shoot-eh500s.service';

@Component({
    selector: 'app-welcome-trouble-shoot-page',
    imports: [CommonModule],
    templateUrl: './welcome-trouble-shoot-page.component.html',
    styleUrl: './welcome-trouble-shoot-page.component.scss'
})
export class WelcomeTroubleShootPageComponent implements OnInit {
  issues: any[] = [];
  deviceData: any = {};
  deviceData$: any = null;
  issueKey: string = '';
  selectedMachineType: string = '';
  qrId: any;
  accountNumber: string = '';
  machineType = MachineType;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private troubleShootEhtService: TroubleShootEhtService,
    private troubleShootEs2000Service: TroubleShootEs2000Service,
    private troubleShootEh500sService: TroubleShootEh500sService,
    private router: Router,
    private route: ActivatedRoute,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    const storedData = this.genericService.getLocalStorage();
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.selectedMachineType = storedData.selectedMachineType;
    this.route.queryParams.subscribe((params) => {
      if (params['machineType']) {
        this.selectedMachineType = params['machineType'];
        this.loadIssues();
      }
    });
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  home() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate([`troubleshoot/${accountNumber}`]);
  }

  loadIssues() {
    if (this.selectedMachineType === this.machineType.ES2000) {
      this.issues =
        this.troubleShootEs2000Service.getTroubleShootEs2000Issues();
    } else if (
      this.selectedMachineType === this.machineType.EHT ||
      this.selectedMachineType === this.machineType.XLHT
    ) {
      this.issues = this.troubleShootEhtService.getTroubleShootEhtIssues();
    } else if (this.selectedMachineType === this.machineType.EH500S) {
      this.issues =
        this.troubleShootEh500sService.getTroubleShootEh500sIssues();
    } else {
      console.warn('No valid machine type found.');
    }
  }

  issueSelection(issueKey: string, issueLabel: any, machineType: string) {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    let targetRoute;
    if (
      machineType === this.machineType.EHT ||
      machineType === this.machineType.XLHT
    ) {
      targetRoute = `issueseht/${accountNumber}/${issueKey}`;
    } else if (machineType === this.machineType.ES2000) {
      targetRoute = `issueses2000/${accountNumber}/${issueKey}`;
    } else if (machineType === this.machineType.ES2000) {
      targetRoute = `issueseh500s/${accountNumber}/${issueKey}`;
    } else {
      console.error(`Unsupported machine type: ${machineType}`);
    }
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate([targetRoute], {
      queryParams: { issueName: issueLabel, issueKey: issueKey },
    });
  }

  start() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    if (!this.selectedMachineType || this.selectedMachineType.trim() === '') {
      alert('Please select a machine type before proceeding.');
      return;
    }
    if (accountNumber) {
      this.deviceData['languageSelected'] = this.currentLanguage;
      this.genericService.setLocalStorage(this.deviceData);
      this.genericService.deviceData.next(this.deviceData);
      this.router.navigate([`issues/${accountNumber}`], {
        queryParams: { machineType: this.selectedMachineType },
      });
    } else {
      console.error('Account number not found. Cannot navigate to issues.');
    }
  }
}
